import AppIcons from "../../assets/images/icons/index";

export default {
  'avatar1': AppIcons.avatar1,
  'avatar2': AppIcons.avatar2,
  'avatar3': AppIcons.avatar3,
  'avatar4': AppIcons.avatar4,
  'avatar5': AppIcons.avatar5,
  'avatar6': AppIcons.avatar6,
  'avatar7': AppIcons.avatar7,
  'avatar8': AppIcons.avatar8,
  'avatar9': AppIcons.avatar9,
  'avatar10': AppIcons.avatar10,
  'avatar11': AppIcons.avatar11,
  'avatar12': AppIcons.avatar12,
  'avatar13': AppIcons.avatar13,
  'avatar14': AppIcons.avatar14,
  'avatar15': AppIcons.avatar15,
  'avatar16': AppIcons.avatar16,
  'avatar17': AppIcons.avatar17,
  'hAvatar1': AppIcons.hAvatar1,
  'hAvatar2': AppIcons.hAvatar2,
  'hAvatar3': AppIcons.hAvatar3,
  'hAvatar4': AppIcons.hAvatar4,
  'hAvatar5': AppIcons.hAvatar5,
  'hAvatar6': AppIcons.hAvatar6,
  'hAvatar7': AppIcons.hAvatar7,
  'hAvatar8': AppIcons.hAvatar8,
  'hAvatar9': AppIcons.hAvatar9,
  'hAvatar10': AppIcons.hAvatar10,
  'bAvatar1': AppIcons.bAvatar1,
  'bAvatar2': AppIcons.bAvatar2,
  'bAvatar3': AppIcons.bAvatar3,
  'bAvatar4': AppIcons.bAvatar4,
  'bAvatar5': AppIcons.bAvatar5,
  'bAvatar6': AppIcons.bAvatar6,
  'bAvatar7': AppIcons.bAvatar7,
  'bAvatar8': AppIcons.bAvatar8,
  'bAvatar9': AppIcons.bAvatar9,
  'bAvatar10': AppIcons.bAvatar10,
  'bAvatar11': AppIcons.bAvatar11,
  'bAvatar12': AppIcons.bAvatar12,
  'bAvatar13': AppIcons.bAvatar13,
  'bAvatar14': AppIcons.bAvatar14,
  'bAvatar15': AppIcons.bAvatar15,
  'bAvatar16': AppIcons.bAvatar16,
  'bAvatar17': AppIcons.bAvatar17,
  'bAvatar18': AppIcons.bAvatar18,
  'bAvatar19': AppIcons.bAvatar19,
}